const FullScreenLayout = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>;
};

export { FullScreenLayout };
